import { render, staticRenderFns } from "./TypeSelect.vue?vue&type=template&id=66347f98&scoped=true&"
import script from "./TypeSelect.vue?vue&type=script&lang=ts&"
export * from "./TypeSelect.vue?vue&type=script&lang=ts&"
import style0 from "./TypeSelect.vue?vue&type=style&index=0&id=66347f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66347f98",
  null
  
)

export default component.exports